import GeneralFilter from '../../../../Model/GeneralFilter'

export default class TrackFilter extends GeneralFilter {
  constructor () {
    super()
    this.setInitialValue()
  }

  setInitialValue () {
    this.setFilterInitialValue()
  }
}
